import React from 'react';
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";


export class RecipePreview extends React.Component {
    /**
     * @returns {*}
     */
    mainStyle = () => {
        if (this.props.subscreen === 'preview') {
            return {display: 'block'}
        }

        return {display: 'none'}
    };

    showEditButton = () => {
        if (this.props.recipe.public !== undefined) {
            return true;
        }

        return false;
    };

    /**
     * @returns {XML}
     */
    render() {
        return (
            <div style={this.mainStyle()}>
                <Button
                    color={'main'}
                    text={TranslationService.trans(this.props.lang, 'common.back')}
                    onClick={() => this.props.openSubscreen('list')}
                />

                <Button
                    color={'accent'}
                    secondary={true}
                    text={TranslationService.trans(this.props.lang, 'common.edit')}
                    onClick={() => this.props.openSubscreen('edit')}
                    display={this.showEditButton()}
                />

                <h1 className="imd-text-main">{this.props.recipe.name}</h1>

                <h2 className="imd-text-20-main">{TranslationService.trans(this.props.lang, 'recipes.ingredients')}</h2>
                <div className="imd-text-accent" style={{whiteSpace: 'pre-line'}}>
                    {this.props.recipe.ingredients}
                </div>

                <h2 className="imd-text-20-main">{TranslationService.trans(this.props.lang, 'recipes.instructions')}</h2>
                <div className="imd-text-accent" style={{whiteSpace: 'pre-line'}}>
                    {this.props.recipe.recipe}
                </div>
            </div>
        );
    }
}
